module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bg-gray"
  }, [_c('div', {
    staticClass: "form-content"
  }, [_c('el-button', {
    directives: [{
      name: "rblink",
      rawName: "v-rblink",
      value: ({
        name: 'DakejianApplySimple'
      }),
      expression: "{name:'DakejianApplySimple'}"
    }],
    staticClass: "mb10",
    attrs: {
      "type": "primary",
      "size": "normal"
    }
  }, [_vm._v("新增申报\n    ")]), _vm._v(" "), _c('el-table', {
    ref: "table",
    attrs: {
      "data": _vm.list,
      "row-key": "id",
      "show-header": false
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": "报名会议",
      "fixed": "left",
      "prop": "title"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('p', [_vm._v(_vm._s(scope.row.name) + "（" + _vm._s(scope.row.phone) + "）")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(scope.row.danwei))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "状态",
      "prop": "zhuantai"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.registstatus == 1) ? _c('el-tag', [_vm._v("\n            提交成功，待审核\n          ")]) : (scope.row.registstatus == 2) ? _c('el-tag', {
          attrs: {
            "type": "success"
          }
        }, [_vm._v("\n            审核成功\n          ")]) : _c('el-tag', {
          attrs: {
            "type": "success"
          }
        }, [_vm._v("\n            审核失败\n          ")])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "操作",
      "prop": "caozuo"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.registstatus == 2) ? _c('el-button', {
          attrs: {
            "size": "medium"
          },
          on: {
            "click": function($event) {
              return _vm.goDetail(scope.row)
            }
          }
        }, [_vm._v("查看详情")]) : _vm._e()]
      }
    }])
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "table-pagination"
  }, [_c('el-pagination', {
    attrs: {
      "background": "",
      "current-page": parseInt(_vm.row.currentpage),
      "page-size": _vm.params.pageSize,
      "layout": "total, prev, pager, next",
      "total": _vm.row.total
    },
    on: {
      "current-change": _vm.handleCurrentChange
    }
  })], 1)], 1), _vm._v(" "), (false) ? _c('div', {
    staticClass: "savebtn"
  }, [_c('van-button', {
    directives: [{
      name: "rblink",
      rawName: "v-rblink",
      value: ({
        name: 'DakejianApplySimple'
      }),
      expression: "{name:'DakejianApplySimple'}"
    }],
    staticStyle: {
      "width": "3rem"
    },
    attrs: {
      "color": "linear-gradient(90deg, rgb(254, 200, 53) 0%, rgb(255, 173, 25) 100%)",
      "size": "normal",
      "round": ""
    }
  }, [_vm._v("新增申报\n    ")])], 1) : _vm._e(), _vm._v(" "), _c('LoginDialog', {
    attrs: {
      "show": _vm.loginShow
    },
    on: {
      "loginSuccess": _vm.loginSuccess,
      "loginCancel": _vm.loginCancel
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-27123a44","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/page/apps/cdakejian/DakejianList.vue
// module id = 1414
// module chunks = 0